import React from 'react';
import { TargetGoal } from 'hooks/useGrouping';
import TargetRelatedConfirmModal from './TargetRelatedConfirmModal';

export const GROUP_DELETE_CONFIRM_MODAL_TYPE = {
  紐付けなし: 0,
  紐付けありかつ目標削除なし: 1,
  紐付けありかつ目標削除あり: 2,
} as const;

export type GroupDeleteConfirmModalType = typeof GROUP_DELETE_CONFIRM_MODAL_TYPE[keyof typeof GROUP_DELETE_CONFIRM_MODAL_TYPE];

const SENTENCE = {
  [GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けなし]: {
    content: (
      <>
        このグループに登録されている資産は未分類となります。このグループを削除しますか？
      </>
    ),
    deleteButtonMessage: '削除する',
  },
  [GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けありかつ目標削除なし]: {
    content: (targetGoal: TargetGoal): JSX.Element => (
      <>
        {`このグループは現在「${targetGoal.title}」の目標達成のための資産に登録されています。`}
        <br />
        削除後は目標の達成状況が変動する可能性があります。このグループを削除してよろしいですか？
      </>
    ),
    deleteButtonMessage: '削除する',
  },
  [GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けありかつ目標削除あり]: {
    content: (targetGoal: TargetGoal): JSX.Element => (
      <>
        {`このグループは現在「${targetGoal.title}」の目標達成のための資産に登録されています。削除後は目標も終了となります。`}
        <br />
        このグループを削除してよろしいですか？
      </>
    ),
    deleteButtonMessage: '目標を終了してグループも終了する',
  },
};

type GroupDeleteConfirmModalProps = {
  delete: () => void;
  isShow: boolean;
  close: () => void;
} & (
  | {
      type: typeof GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けなし;
    }
  | {
      type: typeof GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けありかつ目標削除なし;
      targetGoal: TargetGoal;
    }
  | {
      type: typeof GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けありかつ目標削除あり;
      targetGoal: TargetGoal;
    }
);

const GroupDeleteConfirmModal: React.FC<GroupDeleteConfirmModalProps> = props => {
  const title = 'このグループを削除しますか？';

  const deleteButtonClickHandler = async (): Promise<void> => {
    await props.delete();
    if (
      props.type === GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けなし ||
      props.type === GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けありかつ目標削除なし
    )
      return;
  };
  return (
    <TargetRelatedConfirmModal
      targetGoalId={
        props.type !== GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けなし
          ? props.targetGoal.id
          : undefined
      }
      execute={{
        execute: deleteButtonClickHandler,
        executeButtonMessage: SENTENCE[props.type].deleteButtonMessage,
      }}
      cancel={props.close}
      title={title}
      content={
        props.type === GROUP_DELETE_CONFIRM_MODAL_TYPE.紐付けなし
          ? SENTENCE[props.type].content
          : SENTENCE[props.type].content(props.targetGoal)
      }
      isShow={props.isShow}
      close={props.close}
    />
  );
};

export default GroupDeleteConfirmModal;
